import { writable } from "svelte/store";

interface AuthState {
  authenticated: boolean;
  user: string | null;
  authType: "token" | "password" | null;
}

export const auth = writable<AuthState>({
  authenticated: false,
  user: null,
  authType: null,
});
